import { render, staticRenderFns } from "./StudentPass.vue?vue&type=template&id=01219db4"
import script from "../../../controllers/custom/student/student-pass.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/student/student-pass.js?vue&type=script&lang=js&external"
import style0 from "./StudentPass.vue?vue&type=style&index=0&id=01219db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports